"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEligibilityCoachConso = exports.getEligibilityCoachConsoState = exports.hasMultiSectionSubscriptionOnCurrentCustomerAccount = exports.hasMultiCustomerAccountOnCurrentClientAccount = exports.hasMultiClientAccount = exports.getCurrentSectionSubscription = exports.getCurrentCustomerAccount = exports.getCurrentClientAccount = exports.getCurrentSectionSubId = exports.getCurrentCustomerAccountId = exports.getCurrentClientAccountId = exports.getUpdateContractNameState = exports.isMultiSubscriptionOnly = exports.isNotMultiContract = exports.getSelectedClientAccount = exports.getClientAccounts = exports.getClientContractStatus = exports.getClientAccountsState = void 0;
var EligibilityCoachConso_1 = require("../models/EligibilityCoachConso");
/**
 * Récupérer tout le state
 * @param states
 */
function getClientAccountsState(states) {
    return states === null || states === void 0 ? void 0 : states.clientAccounts;
}
exports.getClientAccountsState = getClientAccountsState;
function getClientContractStatus(states, customerAccountId) {
    var _a, _b;
    var clientAccount = (_b = (_a = states === null || states === void 0 ? void 0 : states.clientAccounts) === null || _a === void 0 ? void 0 : _a.clientAccounts) === null || _b === void 0 ? void 0 : _b.filter(function (s) { return s.customerAccounts.map(function (c) { return c.customerAccountId; }).includes(customerAccountId); });
    var contractTerminated = true;
    if (clientAccount === null || clientAccount === void 0 ? void 0 : clientAccount.length) {
        var customerAccount = clientAccount[0].customerAccounts.filter(function (s) { return s.customerAccountId === customerAccountId; });
        if (customerAccount.length) {
            customerAccount[0].sectionSubscriptions.forEach(function (element) {
                if (!element.isContractTerminated) {
                    contractTerminated = false;
                }
            });
        }
    }
    return contractTerminated;
}
exports.getClientContractStatus = getClientContractStatus;
/**
 * get clientAccounts array from state
 * @param states
 */
function getClientAccounts(states) {
    var _a;
    return (_a = states === null || states === void 0 ? void 0 : states.clientAccounts) === null || _a === void 0 ? void 0 : _a.clientAccounts;
}
exports.getClientAccounts = getClientAccounts;
/**
 * get selected client acount array from state
 * @param states
 */
function getSelectedClientAccount(states) {
    return states.clientAccounts.selectedClientAccount;
}
exports.getSelectedClientAccount = getSelectedClientAccount;
/**
 * isNotMultiContract
 * @param states
 * return boolean
 */
function isNotMultiContract(states) {
    var _a;
    var clientAccounts = (_a = states === null || states === void 0 ? void 0 : states.clientAccounts) === null || _a === void 0 ? void 0 : _a.clientAccounts;
    //there is only one reference or less and there is only one customer accounts and there is only one section subscription
    var result = (clientAccounts &&
        (clientAccounts === null || clientAccounts === void 0 ? void 0 : clientAccounts.length) < 2 &&
        clientAccounts[0].customerAccounts &&
        clientAccounts[0].customerAccounts.length < 2 &&
        clientAccounts[0].customerAccounts[0].sectionSubscriptions &&
        clientAccounts[0].customerAccounts[0].sectionSubscriptions.length < 2);
    return result ? result : false;
}
exports.isNotMultiContract = isNotMultiContract;
/**
 * isMultiSubscriptionOnly
 * @param states
 * return boolean
 */
function isMultiSubscriptionOnly(states) {
    var _a;
    var clientAccounts = (_a = states === null || states === void 0 ? void 0 : states.clientAccounts) === null || _a === void 0 ? void 0 : _a.clientAccounts;
    var result = (clientAccounts &&
        (clientAccounts === null || clientAccounts === void 0 ? void 0 : clientAccounts.length) < 2 &&
        clientAccounts[0].customerAccounts &&
        clientAccounts[0].customerAccounts.length < 2 &&
        clientAccounts[0].customerAccounts[0].sectionSubscriptions &&
        clientAccounts[0].customerAccounts[0].sectionSubscriptions.length >= 2);
    return result ? result : false;
}
exports.isMultiSubscriptionOnly = isMultiSubscriptionOnly;
/**
 * getUpdateContractNameState
 * @param states
 * get updateContractName state from ClientAccount state
 */
function getUpdateContractNameState(states) {
    return {
        errorMessage: states.clientAccounts.updateContractName.errorMessage,
        loading: states.clientAccounts.updateContractName.loading,
        success: states.clientAccounts.updateContractName.success,
        status: states.clientAccounts.updateContractName.status
    };
}
exports.getUpdateContractNameState = getUpdateContractNameState;
// Following selector is use on mobile app
function getCurrentClientAccountId(state) {
    var clientAccountState = getClientAccountsState(state);
    if (clientAccountState && clientAccountState.selectedClientAccount) {
        return clientAccountState.selectedClientAccount.clientId;
    }
    return null;
}
exports.getCurrentClientAccountId = getCurrentClientAccountId;
// Get Id from select client account setting
function getCurrentCustomerAccountId(state) {
    var clientAccountState = getClientAccountsState(state);
    if (clientAccountState && clientAccountState.selectedCustomerAccount) {
        return clientAccountState.selectedCustomerAccount.customerAccountId;
    }
    return null;
}
exports.getCurrentCustomerAccountId = getCurrentCustomerAccountId;
// Get Id from select client account setting
function getCurrentSectionSubId(state) {
    var clientAccountState = getClientAccountsState(state);
    if (clientAccountState && clientAccountState.selectedSectionSubscripiton) {
        return clientAccountState.selectedSectionSubscripiton.sectionSubscriptionId;
    }
    return null;
}
exports.getCurrentSectionSubId = getCurrentSectionSubId;
function getCurrentClientAccount(state) {
    var clientAccounts = getClientAccounts(state);
    var clientid = getCurrentClientAccountId(state);
    if (clientid && clientAccounts && clientAccounts.length !== 0) {
        var selected = clientAccounts.find(function (client) { return client.clientId === clientid; });
        if (selected)
            return selected;
    }
    return null;
}
exports.getCurrentClientAccount = getCurrentClientAccount;
function getCurrentCustomerAccount(state) {
    var clientAccounts = getClientAccounts(state);
    var clientid = getCurrentClientAccountId(state);
    var customerAccountId = getCurrentCustomerAccountId(state);
    if (clientid && customerAccountId && clientAccounts && clientAccounts.length !== 0) {
        var selectedClientAccount = clientAccounts.find(function (client) { return client.clientId === clientid; });
        if (selectedClientAccount) {
            var selectedCustomerAccount = selectedClientAccount.customerAccounts.find(function (client) { return client.customerAccountId === customerAccountId; });
            if (selectedCustomerAccount) {
                return selectedCustomerAccount;
            }
        }
    }
    return null;
}
exports.getCurrentCustomerAccount = getCurrentCustomerAccount;
function getCurrentSectionSubscription(state) {
    var clientAccounts = getClientAccounts(state);
    var clientid = getCurrentClientAccountId(state);
    var customerAccountId = getCurrentCustomerAccountId(state);
    var sectionSubscriptionId = getCurrentSectionSubId(state);
    if (clientid && customerAccountId && sectionSubscriptionId && clientAccounts && clientAccounts.length !== 0) {
        var selectedClientAccount = clientAccounts.find(function (client) { return client.clientId === clientid; });
        if (selectedClientAccount) {
            var selectedCustomerAccount = selectedClientAccount.customerAccounts.find(function (client) { return client.customerAccountId === customerAccountId; });
            if (selectedCustomerAccount) {
                var selectedSectionSubscriptions = selectedCustomerAccount.sectionSubscriptions.find(function (section) { return section.sectionSubscriptionId === sectionSubscriptionId; });
                if (selectedSectionSubscriptions) {
                    return selectedSectionSubscriptions;
                }
            }
        }
    }
    return null;
}
exports.getCurrentSectionSubscription = getCurrentSectionSubscription;
function hasMultiClientAccount(state) {
    var clientAccounts = getClientAccounts(state);
    if (clientAccounts) {
        return clientAccounts.length > 1;
    }
    return null;
}
exports.hasMultiClientAccount = hasMultiClientAccount;
function hasMultiCustomerAccountOnCurrentClientAccount(state) {
    var currentClientAccount = getCurrentClientAccount(state);
    if (currentClientAccount) {
        return currentClientAccount.customerAccounts.length > 1;
    }
    return null;
}
exports.hasMultiCustomerAccountOnCurrentClientAccount = hasMultiCustomerAccountOnCurrentClientAccount;
function hasMultiSectionSubscriptionOnCurrentCustomerAccount(state) {
    var currentCustomerAccount = getCurrentCustomerAccount(state);
    if (currentCustomerAccount) {
        return currentCustomerAccount.sectionSubscriptions.length > 1;
    }
    return null;
}
exports.hasMultiSectionSubscriptionOnCurrentCustomerAccount = hasMultiSectionSubscriptionOnCurrentCustomerAccount;
function getEligibilityCoachConsoState(state) {
    var _a;
    return (_a = state.clientAccounts) === null || _a === void 0 ? void 0 : _a.eligibilityCoachConso;
}
exports.getEligibilityCoachConsoState = getEligibilityCoachConsoState;
/**
 * Selects conditions for the Coach Conso eligibility and neighbor comparison widget
 *
 * @param state The Redux state object
 * @returns An object containing eligibility information : isEligibleCoachConso and withNeighborComparaison
 * @property {boolean} isEligibleCoachConso - Indicates whether the user is eligible for Coach Conso
 * @property {boolean} withNeighborComparaison - Indicates whether neighbor comparison widget could be shown
 */
function getEligibilityCoachConso(state) {
    var _a, _b;
    var ecc = (_a = state.clientAccounts) === null || _a === void 0 ? void 0 : _a.eligibilityCoachConso;
    var ERROR_CUSTOMER_NOT_FOUND = EligibilityCoachConso_1.NotEligibleErrorCodeEnum.ERROR_CUSTOMER_NOT_FOUND;
    // Check if the Coach Conso eligibility: based on success or when error 404 with code != 1 
    var isEligibleCoachConso = (ecc === null || ecc === void 0 ? void 0 : ecc.success) ||
        (((_b = ecc.data) === null || _b === void 0 ? void 0 : _b.isError404) && ecc.data.code !== ERROR_CUSTOMER_NOT_FOUND);
    // Check if we could display Neighbour comparaison widgets: only on success 
    var withNeighborComparaison = ecc === null || ecc === void 0 ? void 0 : ecc.success;
    return {
        isEligibleCoachConso: !!isEligibleCoachConso,
        withNeighborComparaison: !!withNeighborComparaison
    };
}
exports.getEligibilityCoachConso = getEligibilityCoachConso;
